module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_from_30_to_34.195abd7c.webp";